/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListTasksRequest} from '@cash-web/protos/squareup/stafftasks/endpoints/list-tasks.pb'
import {ListTasksResponse} from '@cash-web/protos/squareup/stafftasks/endpoints/list-tasks.pb'


export const listTasks = (request: ListTasksRequest, options?: CashRequestOptions) => post<ListTasksRequest, ListTasksResponse>("/proxy/services/squareup.stafftasks.service.StaffTasksService/ListTasks", request, {...options, rejectOnError: true })